import Swiper from 'swiper/swiper-bundle';
import barba from '@barba/core';
import find from 'lodash/find';
import { WbPopper } from './WbPopper';

export class WbCommerce {
  constructor() {
    this.bindListeners();
    this.inputTimeout = false;
  }

  init() {
    return new Promise((resolve) => {
      this.initSliders();
      this.initCheckout();
      this.toggleShippingFields();
      resolve();
    });
  }

  bindListeners() {
    document.querySelector('body')._addCustomEventListener('click', '.js-add-to-cart', this.addToCart.bind(this));
    document.querySelector('body')._addCustomEventListener('click', '.js-cart-remove', this.removeFromCart.bind(this));
    document
      .querySelector('body')
      ._addCustomEventListener('keyup', '.wb-checkout__item-qty', (e) => this.updateCart(e, true, true, false, 250));
    document.querySelector('body')._addCustomEventListener('click', '.js-update-cart', this.submitCode.bind(this));
    document
      .querySelector('body')
      ._addCustomEventListener('click', '.wb-checkout-sidebar__button--validate', this.validateForm.bind(this));
    document
      .querySelector('body')
      ._addCustomEventListener('submit', '.wb-checkout-sidebar__form', this.updateCart.bind(this));
    document
      .querySelector('body')
      ._addCustomEventListener('submit', '.wb-checkout-sidebar__voucher-form', (e) =>
        this.updateCart(e, true, true, false, 0, true),
      );
    document
      .querySelector('body')
      ._addCustomEventListener('submit', '.wb-checkout-sidebar__form-voucher-remove', (e) =>
        this.updateCart(e, true, true, false, 0, true),
      );
    document
      .querySelector('body')
      ._addCustomEventListener('keyup', '.wb-ticketing-single__ticket-input-qty', this.updateTicketTotal.bind(this));
    document
      .querySelector('body')
      ._addCustomEventListener('keyup', '.wb-product-single__qty', this.updateProductPrice.bind(this));
    document
      .querySelector('body')
      ._addCustomEventListener('click', '[name="shippingMethodHandle"]', this.toggleShippingFields.bind(this));
    document.querySelector('body')._addCustomEventListener('input', '[type="tel"]', this.formatPhoneNumber.bind(this));
    document
      .querySelector('body')
      ._addCustomEventListener('keyup', '[name*="postalCode"]', this.formatPostalCode.bind(this));
  }

  initSliders() {
    const featured = document.querySelector('.wb-product-single-gallery__slider--featured');
    const thumbnails = document.querySelector('.wb-product-single-gallery__slider--thumbnails');
    const featuredParams = {};

    const thumbnailsSlider = new Swiper(thumbnails, {
      slidesPerView: 4,
      spaceBetween: 10,
      loop: false,
      clickable: true,
      navigation: {
        nextEl: '.wb-swiper-btm-bar__arrow--next',
        prevEl: '.wb-swiper-btm-bar__arrow--prev',
        disabledClass: 'wb-swiper-btm-bar__arrow--disabled',
      },
      on: {
        lock: function () {
          this.el.querySelector('.wb-swiper-btm-bar')._hide(0);
        },
        unlock: function () {
          this.el.querySelector('.wb-swiper-btm-bar')._show(0);
        },
      },
      breakpoints: {
        576: {
          spaceBetween: 15,
        },
      },
    });

    if (thumbnailsSlider.el) {
      featuredParams.thumbs = {
        swiper: thumbnailsSlider,
      };
    }

    const featuredSlider = new Swiper(featured, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      ...featuredParams,
    });
  }

  initCheckout() {
    document.dispatchEvent(new Event('_checkout_loaded'));
  }

  toggleAjaxOverlay(forceClose = false) {
    const overlayIsActive = document.querySelector('#page').classList.contains('wb-load-overlay');

    if (!overlayIsActive && !forceClose) {
      const icon = document.createElement('div');
      icon.classList.add('wb-load-overlay__icon');

      document.querySelector('#page').classList.add('wb-load-overlay');
      document.querySelector('body').appendChild(icon);
    } else {
      document.querySelector('.wb-load-overlay')?.classList.remove('wb-load-overlay');
      document.querySelectorAll('.wb-load-overlay__icon')?.forEach((icon) => icon._remove());
    }
  }

  addToCart(e) {
    e.preventDefault();

    const _this = this;
    const form = e.targetElement.closest('form');
    const purchasables = [];

    this.updateCart(e, false).then(() => {
      e.preventDefault();

      document.querySelectorAll('.wb-tab-panel:not([hidden]) [data-purchasable]').forEach((element) => {
        const purchasable = JSON.parse(element.dataset.purchasable);

        if (purchasable.qty > 0) {
          purchasables.push({
            item_name: purchasable.title,
            item_id: purchasable.id,
            item_category: purchasable.type,
            item_sku: purchasable.sku,
            item_image: purchasable.image,
            item_url: purchasable.url,
            price: parseFloat(purchasable.price),
            quantity: parseInt(purchasable.qty),
          });
        }
      });

      window.dispatchEvent(new CustomEvent('craft.commerce.add_to_cart', { detail: purchasables }));

      form.reset();
      _this.toggleAjaxOverlay(true);

      if (form.classList.contains('wb-product-single__form')) {
        _this.updateProductPrice(e, 0);
      } else if (form.classList.contains('wb-ticketing-single__form')) {
        _this.updateTicketTotal(e, 0);
      }
    });
  }

  updateCartQty() {
    return fetch('/actions/commerce/cart/get-cart', {
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        const { totalQty } = data.cart;
        document.querySelectorAll('.wb-cart-qty')?.forEach((qty) => (qty.innerText = totalQty));
      })
      .catch((error) => console.error(error));
  }

  updateCart(e, checkout = true, prevent = true, redirect = false, duration = 0, isVoucher = false) {
    if (prevent) e.preventDefault();

    clearTimeout(this.inputTimeout);

    return new Promise((resolve) => {
      this.inputTimeout = setTimeout(async () => {
        const _this = this;
        let form = e;
        let url = '/actions/commerce/cart/update-cart';
        if (!isVoucher && e.target) {
          form = e.target.closest('form');
        } else if (isVoucher && e.target) {
          form = e.target.closest('.wb-checkout-sidebar__voucher-form, form');
          url = form.querySelector('input[name="action"]')?.value || '';
        }

        let formData = new FormData(form);
        formData.append('clearNotices', '');

        _this.toggleAjaxOverlay();

        return fetch(url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: formData,
        })
          .then((response) => {
            if (!response.ok) {
              if (response.status !== 400) {
                _this.toggleAjaxOverlay();
                throw Error(response.statusText);
              }
            }
            return response.json();
          })
          .then((data) => {
            if (data.errors) {
              _this.addCartNotices(data);
              _this.addFormErrors(data.errors);
              _this.toggleAjaxOverlay();
            } else {
              if ((url === 'gift-voucher/cart/add-code' || url === 'gift-voucher/cart/remove-code') && data?.success) {
                data.message = 'Panier mis à jour';
              }
              _this.updateCartQty();
              _this.addCartNotices(data);

              if (redirect) {
                _this.toggleAjaxOverlay();

                if (_this.isGoingToPaymentPage(data)) {
                  barba.force(data.redirect.replace('shipping', 'payment').replace('expedition', 'paiement'));
                } else {
                  barba.go(data.redirect);
                }
              } else if (checkout) {
                if (isVoucher) {
                  const pageForm = document.querySelector('.wb-checkout-sidebar__form');
                  formData = new FormData(pageForm);
                  formData.append('clearNotices', '');
                }
                _this.getCheckoutStep(formData).then(() => {
                  _this.addCartNotices(data);
                });
              }
              resolve(data);
            }
          })
          .catch((error) => console.error(error));
      }, duration);
    });
  }

  updateTicketTotal(e, duration = 250) {
    clearTimeout(this.inputTimeout);

    this.inputTimeout = setTimeout(() => {
      const tickets = document.querySelectorAll('.wb-ticketing-single__ticket');
      const totalQty = document.querySelector('.wb-ticketing-single__total-qty');
      const totalPrice = document.querySelector('.wb-ticketing-single__total-price-currency');
      const summary = [...tickets].reduce(
        (acc, ticket) => {
          const qty = Number(ticket.querySelector('.wb-ticketing-single__ticket-input-qty').value);
          const price = parseFloat(
            ticket
              .querySelector('.wb-ticketing-single__ticket-price-el--sale')
              .textContent.replace(',', '.')
              .replace(/\s/g, ''),
          ).toFixed(2);

          const purchasable = JSON.parse(ticket.dataset.purchasable);
          purchasable.qty = qty;
          purchasable.price = price;
          ticket.dataset.purchasable = JSON.stringify(purchasable);

          acc.qty += qty;
          acc.total += qty * price;
          return acc;
        },
        { qty: 0, total: 0 },
      );

      totalQty.textContent = totalQty.textContent.replace(/\d+/g, summary.qty);
      totalPrice.textContent = summary.total.toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' });
    }, duration);
  }

  updateProductPrice(e, duration = 250) {
    clearTimeout(this.inputTimeout);

    this.inputTimeout = setTimeout(() => {
      const _this = this;

      const form = e.target.closest('form');
      const urlParams = new URLSearchParams(new FormData(form));
      const qty = Number(form.querySelector('.wb-product-single__qty').value);
      const totalBasePrice = form.querySelector('.wb-product-single__price-total-el--base');
      const totalSalePrice = form.querySelector('.wb-product-single__price-total-el--sale');
      const basePrice = form.querySelector('.wb-product-single__price-el--base');
      const salePrice = form.querySelector('.wb-product-single__price-el--sale');

      _this.toggleAjaxOverlay();

      fetch('/acq/api/price?' + urlParams, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Cache-Control': 'no-cache',
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((response) => {
          if (!response.ok) {
            _this.toggleAjaxOverlay();
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.json())
        .then((data) => {
          const newTotalSale = qty * data.current;

          if (data.current !== data.default) {
            const newTotalBase = qty * data.default;

            basePrice.textContent = `${data.default.toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' })}`;
            totalBasePrice.textContent = newTotalBase.toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' });
          } else {
            basePrice.textContent = '';
            totalBasePrice.textContent = '';
          }

          salePrice.textContent = data.current.toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' });
          totalSalePrice.textContent = newTotalSale.toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' });

          const purchasable = JSON.parse(form.dataset.purchasable);
          purchasable.qty = qty;
          purchasable.price = parseFloat(data.current);
          form.dataset.purchasable = JSON.stringify(purchasable);

          _this.toggleAjaxOverlay();
        })
        .catch((error) => console.error(error));
    }, duration);
  }

  getCheckoutStep(formData) {
    const _this = this;

    return fetch(formData.get('url'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          this.toggleAjaxOverlay();
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.text())
      .then((data) => {
        const PARSER = new DOMParser();
        const DOC = PARSER.parseFromString(data, 'text/html');
        const currentCheckout = document.querySelector('.wb-checkout');
        const newCheckout = DOC.querySelector('.wb-checkout');
        const isCart = document.querySelector('.checkout-cart');

        if (isCart) {
          currentCheckout.replaceWith(newCheckout);

          const tooltips = new WbPopper();
          tooltips.init();
        } else {
          const currentSidebar = document.querySelector('.wb-checkout-sidebar');
          const newSidebar = DOC.querySelector('.wb-checkout-sidebar');
          currentSidebar.replaceWith(newSidebar);
        }

        _this.toggleAjaxOverlay();
      })
      .catch((error) => console.error(error));
  }

  removeFromCart(e) {
    const input = e.target.closest('.wb-checkout__item').querySelector('.wb-checkout__item-removed');
    input.checked = true;

    this.updateCart(e);
  }

  submitCode(e) {
    e.preventDefault();

    this.updateCart(e, true);
  }

  async validateForm(e) {
    const button = e.target.closest('button') ?? e.target;
    const formId = button.getAttribute('form');
    const form = document.querySelector(`#${formId}`);
    const optin = document.querySelector('#optinKlaviyo') ?? null;
    const formData = new FormData(form);
    const regex = /payment|paiement/gm;
    const isGoingToPaymentPage = formData.get('redirect').match(regex);

    if (form.checkValidity() && form.getAttribute('id') !== 'paymentForm' && !isGoingToPaymentPage) {
      e.preventDefault();
      if (optin && optin.checked) {
        await window.KlaviyoAPI.subscribe({
          subscribe: 1,
          'profile[email]': formData.get('email'),
          list: 'QRWstk',
        });
      }
      await this.updateCart(form, false, false, true);
    }

    if(form.checkValidity() && form.getAttribute('id') === 'wb-checkout-tickets' && isGoingToPaymentPage) {
      e.preventDefault();

      if(window.WbParticipants.validate()) {
        await this.updateCart(form, false, false, true);
      }
    }
  }

  addFormErrors(errors) {
    const keys = Object.keys(errors);
    const billingAddressSameAsShipping = document.querySelector('#billingAddressSameAsShipping')?.checked;

    document.querySelectorAll('.fui-error-message')?._remove();

    keys?.forEach((error) => {
      let id = error.replace('.', '-');
      const base = document.createElement('div');
      const ref = document.querySelector(`#${id}`);

      if (billingAddressSameAsShipping && error.includes('billingAddress')) {
        return;
      }

      if (error === 'billingAddress') id = 'billingAddress-countryCode';
      if (error === 'shippingAddress') id = 'shippingAddress-countryCode';

      base.classList.add('fui-error-message');
      base.innerHTML = errors[error][0];

      if (ref) document.querySelector('body')._insertAfter(base, ref);
    });
  }

  addCartNotices(response) {
    const notice = document.querySelector('.wb-notice');
    const billingAddressSameAsShipping = document.querySelector('#billingAddressSameAsShipping')?.checked;

    if (notice) {
      notice.innerHTML = '';
      const invalidPromoCode = response.cart?.notices?.find((e) => e.type === 'invalidCouponRemoved');
      let statusMsg = '';
      if (response?.message) {
        statusMsg =
          '<p class="h4">' +
          response?.message?.replace('Panier', `<a href='${self.location.origin}/achat/panier'>Panier</a>`) +
          '</p>';
      }
      notice.classList.remove('--error', '--success');

      if (response.errors && !response?.success) {
        statusMsg += '<ul>';

        Object.keys(response.errors).forEach((error) => {
          if (billingAddressSameAsShipping && error.includes('billingAddress')) {
            return;
          }

          statusMsg += '<li>' + response.errors[error] + '</li>';
        });

        statusMsg += '</ul>';

        notice.classList.add('--error');
      } else if (invalidPromoCode && !response?.success) {
        statusMsg += `<ul><li>${invalidPromoCode.message}</li></ul>`;
        notice.classList.add('--error');
      } else {
        notice.classList.add('--success');
      }

      notice.innerHTML = statusMsg;
      WbScrollTo.scrollTo({ element: 'main' });
    }
  }

  toggleShippingFields(e) {
    const showFields =
      (e?.target?.value && e?.target?.value == 'customShipping') ?? document.querySelector('#customShipping')?.checked;
    const customShippingFieldsWrapper = document.querySelector('#customShippingFields');
    const customShippingFields = customShippingFieldsWrapper?.querySelectorAll('input');

    if (showFields) {
      customShippingFieldsWrapper?._show(0);
      customShippingFields?.forEach((field) => field.setAttribute('required', ''));
    } else {
      customShippingFieldsWrapper?._hide(0);
      customShippingFields?.forEach((field) => field.removeAttribute('required'));
    }
  }

  formatPhoneNumber(e) {
    const x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
  }

  formatPostalCode(e) {
    if (e.key !== 'Backspace') {
      e.target.value = e.target.value.toUpperCase().replace(/\W/g, '').replace(/(...)/, '$1 ');
    }
  }

  isGoingToPaymentPage(cart) {
    const regex = /shipping|expedition/gm;
    const isGoingToShipping = cart.redirect.match(regex);

    if (!isGoingToShipping) {
      return false;
    }

    const hasShippingMethodAboveZero = find(cart.cart.availableShippingMethodOptions, (e) => e.price > 0);

    if (hasShippingMethodAboveZero) {
      return false;
    }

    return true;
  }
}
